import repository from '@/repositories/repository'
const resource = 'sale-inventories'
export default {
  variables(identifier = 'saleInv') {
    return {
      [`${identifier}List`]: [],
      [`${identifier}Loading`]: false,
      [`${identifier}Errors`]: [],
    }
  },
  export() {
    return repository.get(`${resource}/export`)
  },
  import({ data, columns, unique }) {
    return repository.post(`${resource}/import`, { data, columns, unique })
  },
  totalAmount() {
    return repository.get(`${resource}/total`)
  },
  store(data) {
    return repository.post(`${resource}`, { data })
  },
  storeIndex(storeId, params) {
    return repository.get(`${resource}/store/${storeId}`, { params })
  },
  receiptCount(params) {
    return repository.get(`${resource}/receipts/count`, { params })
  },
  receipts(params) {
    return repository.get(`${resource}/receipts`, { params })
  },
  receiptsV2(params) {
    return repository.get(`${resource}/v2/receipts`, { params })
  },
  storeIndexAll(storeId, params) {
    return repository.get(`${resource}/store/${storeId}/all`, { params })
  },
  storeCount(storeId, params) {
    return repository.get(`${resource}/store/${storeId}/count`, { params })
  },
  countExport() {
    return repository.get(`${resource}/export/count`)
  },
  weeklyBranch(storeId, params) {
    return repository.get(`${resource}/summary/weekly/${storeId}`, { params })
  },
  monthlyBranch(storeId, params) {
    return repository.get(`${resource}/summary/monthly/${storeId}`, { params })
  },
  yearlyBranch(storeId, params) {
    return repository.get(`${resource}/summary/yearly/${storeId}`, { params })
  },
  weeklyAll(params) {
    return repository.get(`${resource}/summary/all/weekly`, { params })
  },
  monthlyAll(params) {
    return repository.get(`${resource}/summary/all/monthly`, { params })
  },
  yearlyAll(params) {
    return repository.get(`${resource}/summary/all/yearly`, { params })
  },
  saleTrend(params) {
    return repository.get(`${resource}/sale-trend`, { params })
  },
  topSales(params) {
    return repository.get(`${resource}/top-sales`, { params })
  },
  filterNewReceipts(receipts) {
    return repository.post(`${resource}/filter-new-receipts`, { receipts })
  },
}
